import styled, { css } from "styled-components";
import { Colors } from "core/constants";
import {
  GetMarginStyle,
  getMarginStyle,
  GetPaddingStyle,
  getPaddingStyle,
} from "core/styles/paddingMarginStyle";

export type ContainerStyle = {
  gap?: number;
  width?: string;
  variant?: "small";
} & GetPaddingStyle &
  GetMarginStyle;

export const Container = styled.div<ContainerStyle>`
  height: ${({ variant }) => (variant === "small" ? "16px" : "24px")};
  left: 0px;
  top: 0px;
  display: flex;
  width: ${({ width }) => width || "100%"};
  gap: ${({ gap }) => gap && `${gap}px`};
  align-items: center;

  p {
    margin-left: 4px;
  }

  ${getPaddingStyle}
  ${getMarginStyle}
`;

export const Slider = styled.div<{ isChecked: boolean; variant?: "small"; disabled?: boolean }>`
  position: relative;
  width: ${({ variant }) => (variant === "small" ? "32px" : "42px")};
  height: ${({ variant }) => (variant === "small" ? "16px" : "24px")};
  border-radius: 9999px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  background: ${({ isChecked, theme }) =>
    isChecked ? theme?.colors?.primary.default : theme?.colors?.neutral.neutral50};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const BallSlider = styled.div<{ isChecked: boolean; variant?: "small" }>`
  border-radius: 50%;
  position: absolute;
  top: ${({ variant }) => (variant === "small" ? "2px" : "4px")};
  left: ${({ variant }) => (variant === "small" ? "2px" : "4px")};
  width: ${({ variant }) => (variant === "small" ? "12px" : "16px")};
  height: ${({ variant }) => (variant === "small" ? "12px" : "16px")};
  border: 1px solid ${({ theme }) => theme?.colors?.primary.pressed};
  background-color: ${({ theme }) => theme?.colors?.white};
  -webkit-transition: 0.4s;
  transition: 0.4s;

  ${({ isChecked, variant }) => {
    if (isChecked)
      return css`
        transform: translateX(${variant === "small" ? "14px" : "18px"});
      `;
  }}
`;
